/* unplugin-vue-components disabled */import script from "./lectureEndCardNew.vue?vue&type=script&setup=true&lang=js"
export * from "./lectureEndCardNew.vue?vue&type=script&setup=true&lang=js"

import "./lectureEndCardNew.vue?vue&type=style&index=0&id=a188e45c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a188e45c"]])

export default __exports__